/* eslint-disable */
import {
  formatFixedProfitHeaderInfo,
  formatFloatCurrencyHeaderInfo,
  formatFloatProfitAndNetFixedProfitHeaderInfo,
  formatHeaderBottomInfo,
  handleAchievementData,
  handleHeaderTags,
  handleHighEndArchivesInfo,
  handleHighEndLightPointInfo,
  handleHighEndTips,
  handleRiskData,
  handleStageRiseListInfo,
  handleTradeMustKnowProgressInfo,
  handleTradeRuleInfo,
} from '@/utils/high-end-format';
import tool from '@/utils/tool';
import { formatDate } from '@fund/basic-lib/dist/lib/date';
import isEmpty from '@fund/basic-lib/dist/lib/lang/isEmpty';
import { numeral } from '@fund/basic-lib/dist/lib/numeral';
import dayjs from 'dayjs';
import Model, { valueWithArray } from 'ducker-model';

const readTitleMap = {
  brightPoint: { title: '产品亮点', icon: 'https://fundrs.dfcfw.com/cos/1257107291/d6a78d63b38143f48db97685bddec928.png' },
  direction: { title: '投资方向', icon: 'https://fundrs.dfcfw.com/cos/1257107291/c0ca88be74374b62be133b4a3c14eb3b.png' },
  strategy: { title: '策略理念', icon: 'https://fundrs.dfcfw.com/cos/1257107291/b9fe30dc03b5465784e6c3dc6d191e67.png' },
  achievement: { title: '业绩概述', icon: 'https://fundrs.dfcfw.com/cos/1257107291/977f701452364bdf979da45c590dba32.png' },
  manageAbility: { title: '管理能力', icon: 'https://fundrs.dfcfw.com/cos/1257107291/256f6a1811124b509699d99985c4d7aa.png' },
  interpretImg: { title: '', icon: '' },
};
const SameTypeProperty = {
  sellState: Number, // 销售状态
  sylOfYear: String, // 近一年收益率
  sylOfEstablish: String, // 成立以来收益率
  profitAnnual: String, // 业绩计提基准
  fundSerise: String, // 基金系列
  fundSeriseName: String, // 基金系列名称
  ipoEndDate: String, // 募集结束日期
  riskLevel: String, // 风险等级
  operationPeriod: String, // 运作期限
  minInvest: String, // 起投金额
  fundName: String, // 基金名称
  fundCode: String, // 基金代码
};

const SameTypeReplacedKeyFromPropertyName = {
  sellState: {
    property: ['SELLSTATE2'],
    DefaultValue: 0,
    computed: ([value]) => Number(value),
  },
  sylOfYear: {
    property: ['Y'],
    defaultValue: '--',
    computed: ([value]) => (isEmpty(value) ? '--' : `${numeral(value).format('0.00')}%`),
  },
  sylOfEstablish: {
    property: ['SE'],
    defaultValue: '--',
    computed: ([value]) => (isEmpty(value) ? '--' : `${numeral(value).format('0.00')}%`),
  },
  profitAnnual: {
    property: ['PROFITANNUAL'],
    defaultValue: '--',
    computed: ([value]) => (isEmpty(value) ? '--' : `${numeral(value).format('0.00')}%`),
  },
  fundSerise: {
    property: ['FTYPE'],
    defaultValue: '',
    computed: ([value]) => value,
  },
  fundSeriseName: {
    property: ['FTYPE'],
    defaultValue: '',
    computed: ([value]) => value,
  },
  ipoEndDate: {
    property: ['IPOENDDATE'],
    defaultValue: '',
    computed: ([value]) => value,
  },
  riskLevel: {
    property: ['RISKLEVEL'],
    defaultValue: '',
    computed: ([value]) => tool.getRiskLevel(value),
  },
  operationPeriod: {
    property: ['OPERATIONPERIOD', 'EXPIRESPECIALTYPE'],
    defaultValue: '',
    computed: ([value, EXPIRESPECIALTYPE]) => (isEmpty(value) ? '无锁定期' : `${value}${EXPIRESPECIALTYPE ? '锁定期' : '投资期'}`),
  },
  minInvest: {
    property: ['MININVEST'],
    defaultValue: '',
    computed: ([value]) => `${value > 10000 ? `${value / 10000}万` : `${value}`}`,
  },
  fundName: {
    property: ['FUNDNAME'],
    defaultValue: '',
    computed: ([value]) => value,
  },
  fundCode: {
    property: ['FUNDCODE'],
    defaultValue: '',
    computed: ([value]) => value,
  },
};
const SameTypeModel = new Model(SameTypeProperty, SameTypeReplacedKeyFromPropertyName);
const ProfitProperty = {
  achieveType: String, // 业绩类型
  achieveSection: String, // 业绩区间
  achieveEffectiveDate: String, // 业绩生效日期
  accrualRate: String, // 计提利率
};

const ProfitReplacedKeyFromPropertyName = {
  achieveType: {
    property: ['ACHIEVETYPE'],
    defaultValue: '',
    computed: ([achieveType]) => (isEmpty(achieveType) ? '' : achieveType),
  },
  achieveSection: {
    property: ['ACHIEVESECTION'],
    defaultValue: '',
    computed: ([value]) => value,
  },
  achieveEffectiveDate: {
    property: ['ACHIEVEEFFDATE'],
    defaultValue: '',
    computed: ([value]) => value,
  },
  accrualRate: {
    property: ['ACCRUALRATE'],
    defaultValue: '--',
    computed: ([accrualRate]) => (isEmpty(accrualRate) ? '--' : `${numeral(accrualRate).format('0.00')}%`),
  },
};
const ProfitModel = new Model(ProfitProperty, ProfitReplacedKeyFromPropertyName);
const property = {
  highEndVideoInfo: Object, // 视频信息
  nSmallType: String, // 高端理财二级分类(请求FundIndexDiy要用)
  benchMark: String, // 业绩计提基准
  headerTags: valueWithArray(Object), // 头部标签
  floatCurrencyHeaderInfo: Object, // 浮动货币头部信息
  fixedProfitHeaderInfo: Object, // 固定收益头部信息
  floatProfitAndNetFixedProfitHeaderInfo: Object, // 浮动收益和净值修复头部信息
  headerBottomInfo: Object, // 头部底部信息
  highEndTipsInfo: String,
  highEndLightPointInfo: Object,
  profitAnnual: String,
  stageRiseListInfo: Object,
  tradeMustKnowProgressInfo: valueWithArray(Object),
  tradeRuleInfo: Object,
  highEndArchives: Object,
  productPeriodInfo: Object,
  fixedBottomBtnInfo: Object,
  achievementData: valueWithArray(Object),
  riskData: valueWithArray(Object),
  onePageRead: Object,
  sameTypeProduct: valueWithArray(Object),
  optimalInfo: Object,
  bonusInfo: Object,
  manager: Object,
  isOrganizeRecommend: Boolean,
  managerName: String,
  nextOpenDate: String,
  netFixInfo: Object,
  profitInfo: Object,
  isShowFundSize: Boolean,
  redemAndAchieveInfo: Object,
  hasSeasonReport: Boolean,
  readInfo: valueWithArray(Object),
  readUpdateTime: String,
  noticeData: Object,
  promotionModuleConfig: Object,
  noticeInfo: Object,
  historyProfitInfo: Object,
  achievePoint: Object,
  isHighEndEnjoy: Boolean,
};

const replaceProperty = {
  highEndVideoInfo: {
    property: ['FundGDLCInfos[0].PHOTO', 'FundGDLCInfos[0].PHOTOHTTP'],
    defaultValue: {},
    computed: ([photo, photoLink]) => ({ photo, photoLink }),
  },

  nSmallType: {
    property: ['FundGDLCInfos[0].NSMALLTYPE2'],
    defaultValue: '',
    computed: ([value]) => value,
  },

  benchMark: {
    property: ['FundGDLCInfos[0].BENCHMARK'],
    defaultValue: '',
    computed: ([value]) => value,
  },

  headerTags: {
    property: ['FundGDLCInfos[0].RISKLEVEL', 'FundGDLCInfos[0].CARD', 'FundGDLCInfos[0].NSMALLTYPE2', 'promotionConfigLabel'],
    computed: ([riskLevel, CARD, NSMALLTYPE, promotionConfigLabel]) =>
      handleHeaderTags({
        riskLevel,
        CARD,
        NSMALLTYPE,
        promotionConfigLabel,
      }),
  },

  floatCurrencyHeaderInfo: {
    property: ['FundGDLCInfos[0].MUI', 'FundGDLCInfos[0].JZRQ', 'FundGDLCInfos[0].SYI'],
    computed: ([mui, jzrq, syi]) =>
      formatFloatCurrencyHeaderInfo({
        mui,
        jzrq,
        syi,
      }),
  },

  fixedProfitHeaderInfo: {
    property: ['FundGDLCInfos[0].PROFITANNUAL'],
    computed: ([profitAnnual]) =>
      formatFixedProfitHeaderInfo({
        profitAnnual,
      }),
  },

  floatProfitAndNetFixedProfitHeaderInfo: {
    property: [
      'FundGDLCInfos[0].JZRQ',
      'FundGDLCInfos[0].NAV',
      'FundGDLCInfos[0].Y',
      'FundGDLCInfos[0].SE',
      'FundGDLCInfos[0].PROFITANNUAL',
      'FundGDLCInfos[0].OVERCARRY',
      'FundGDLCInfos[0].ANNUAL',
      'FundGDLCInfos[0].STABILSHDATE',
      'FundGDLCInfos[0].ACHIEVESECTION',
      'FundGDLCInfos[0].ACHIEVETYPE',
    ],
    computed: ([JZRQ, NAV, Y, SE, PROFITANNUAL, OVERCARRY, ANNUAL, STABILSHDATE, ACHIEVESECTION, ACHIEVETYPE]) =>
      formatFloatProfitAndNetFixedProfitHeaderInfo({
        JZRQ,
        NAV,
        Y,
        SE,
        OVERCARRY,
        PROFITANNUAL,
        ANNUAL,
        STABILSHDATE,
        ACHIEVESECTION,
        ACHIEVETYPE,
      }),
  },

  headerBottomInfo: {
    property: [
      'FundGDLCInfos[0].EXPIRESPECIALTYPE',
      'FundGDLCInfos[0].OPERATIONPERIOD',
      'FundGDLCInfos[0].MININVEST',
      'FundGDLCInfos[0].ISNEW',
      'FundGDLCInfos[0].FTYPE',
    ],
    computed: ([EXPIRESPECIALTYPE, OPERATIONPERIOD, minInvest, isNew, fType]) =>
      formatHeaderBottomInfo({
        EXPIRESPECIALTYPE,
        OPERATIONPERIOD,
        minInvest,
        isNew,
        fType,
      }),
  },

  highEndTipsInfo: {
    property: ['FundGDLCInfos[0].PROFITANNUAL', 'FundGDLCInfos[0].OVERCARRY'],
    computed: ([PROFITANNUAL, OVERCARRY]) => handleHighEndTips({ PROFITANNUAL, OVERCARRY }),
  },

  highEndLightPointInfo: {
    property: ['FundGDLCInfos[0].REMARK', 'FundGDLCInfos[0].REMARK_URL', 'FundGDLCInfos[0].FCODE'],
    computed: ([remark, url, fundCode]) => handleHighEndLightPointInfo({ remark, url, fundCode }),
  },

  profitAnnual: {
    property: ['FundGDLCInfos[0].PROFITANNUAL'],
    defaultValue: '--',
    computed: ([value]) => (isEmpty(value) ? '--' : `${numeral(value).format('0.00')}%`),
  },

  stageRiseListInfo: {
    property: [
      'FundGDLCInfos[0].JZRQ',
      'FundGDLCInfos[0].SE',
      'FundGDLCInfos[0].W',
      'FundGDLCInfos[0].M',
      'FundGDLCInfos[0].Q',
      'FundGDLCInfos[0].HY',
      'FundGDLCInfos[0].Y',
      'FundGDLCInfos[0].TWY',
      'FundGDLCInfos[0].TRY',
      'FundGDLCInfos[0].FY',
      'FundGDLCInfos[0].SY',
      'hisRank',
    ],
    computed: ([date, se, w, m, q, hy, y, twy, threeY, fy, sy, hisRank]) =>
      handleStageRiseListInfo({
        date,
        se,
        w,
        m,
        q,
        hy,
        y,
        twy,
        threeY,
        fy,
        sy,
        hisRank,
      }),
  },

  tradeMustKnowProgressInfo: {
    property: [
      'FundGDLCInfos[0].FUNDBUSINTYPE',
      'FundGDLCInfos[0].CLOSEDAYS',
      'FundGDLCInfos[0].SELLSTATE2',
      'FundGDLCInfos[0].IPOBEGINDATE',
      'FundGDLCInfos[0].IPOENDDATE',
      'FundGDLCInfos[0].STABILSHDATE',
      'FundGDLCInfos[0].MARKETBEGINDATE',
      'FundGDLCInfos[0].NEXTBEGINDATE',
      'FundGDLCInfos[0].MARKETENDDATE',
    ],
    computed: ([FUNDBUSINTYPE, CLOSEDAYS, SELLSTATE2, IPOBEGINDATE, IPOENDDATE, STABILSHDATE, MARKETBEGINDATE, NEXTBEGINDATE, MARKETENDDATE]) =>
      handleTradeMustKnowProgressInfo({
        FUNDBUSINTYPE,
        CLOSEDAYS,
        SELLSTATE: SELLSTATE2,
        IPOBEGINDATE,
        IPOENDDATE,
        STABILSHDATE,
        MARKETBEGINDATE,
        NEXTBEGINDATE,
        MARKETENDDATE,
      }),
  },

  tradeRuleInfo: {
    property: [
      'FundGDLCInfos[0].FUNDBUSINTYPE',
      'FundGDLCInfos[0].MARKETBEGINDATE',
      'FundGDLCInfos[0].MARKETENDDATE',
      'FundGDLCInfos[0].OPENRULE',
      'FundGDLCInfos[0].OPERATIONPERIOD',
      'FundGDLCInfos[0].MININVEST',
      'FundGDLCInfos[0].MINAPPEND',
      'FundGDLCInfos[0].SGRATEMARK',
      'FundGDLCInfos[0].RATE',
      'FundGDLCInfos[0].REDEEMBEGINDATE',
      'FundGDLCInfos[0].REDEEMENDDATE',
      'FundGDLCInfos[0].SHRATEMARK',
      'FundGDLCInfos[0].EXPIRESPECIALTYPE',
      'FundGDLCInfos[0].REMARK',
      'FundGDLCInfos[0].PERFORMANCEFEE',
    ],
    computed: ([
      FUNDBUSINTYPE,
      MARKETBEGINDATE,
      MARKETENDDATE,
      OPENRULE,
      OPERATIONPERIOD,
      MININVEST,
      MINAPPEND,
      SGRATEMARK,
      RATE,
      REDEEMBEGINDATE,
      REDEEMENDDATE,
      SHRATEMARK,
      EXPIRESPECIALTYPE,
      REMARK,
      PERFORMANCEFEE,
    ]) =>
      handleTradeRuleInfo({
        FUNDBUSINTYPE,
        MARKETBEGINDATE,
        MARKETENDDATE,
        OPENRULE,
        OPERATIONPERIOD,
        MININVEST,
        MINAPPEND,
        SGRATEMARK,
        RATE,
        REDEEMBEGINDATE,
        REDEEMENDDATE,
        SHRATEMARK,
        EXPIRESPECIALTYPE,
        REMARK,
        PERFORMANCEFEE,
      }),
  },

  highEndArchives: {
    property: [
      'FundGDLCInfos[0].FUNDCODE',
      'FundGDLCInfos[0].FUNDNAME',
      'FundGDLCInfos[0].STABILSHDATE',
      'FundGDLCInfos[0].WHOLELIMIT',
      'FundGDLCInfos[0].MNGSCALE',
      'FundGDLCInfos[0].REGCAPITAL',
      'FundGDLCInfos[0].FOUNDDATE',
      'FundGDLCInfos[0].FUNDMANAGER',
      'FundGDLCInfos[0].INVESTMENTMANAGERINTRO',
      'FundGDLCInfos[0].MANAGER',
      'FundGDLCInfos[0].MANAGEMENTINTRO',
      'managerInfo',
      'FundGDLCInfos[0].MANAGERCODE',
    ],
    computed: ([
      fundCode,
      fundName,
      STABILSHDATE,
      WHOLELIMIT,
      MNGSCALE,
      REGCAPITAL,
      FOUNDDATE,
      FUNDMANAGER,
      INVESTMENTMANAGERINTRO,
      MANAGER,
      MANAGEMENTINTRO,
      managerInfoList,
      managerCode,
    ]) =>
      handleHighEndArchivesInfo({
        fundCode,
        fundName,
        STABILSHDATE,
        WHOLELIMIT,
        MNGSCALE,
        REGCAPITAL,
        FOUNDDATE,
        FUNDMANAGER,
        INVESTMENTMANAGERINTRO,
        MANAGER,
        MANAGEMENTINTRO,
        managerInfoList,
        managerCode,
      }),
  },

  productPeriodInfo: {
    property: [
      'FundGDLCInfos[0].MARKETENDDATE',
      'FundGDLCInfos[0].SELLSTATE2',
      'FundGDLCInfos[0].MARKETBEGINDATE',
      'FundGDLCInfos[0].GSVALUEDATE',
      'FundGDLCInfos[0].ISAUTOCONTINUE',
      'FundGDLCInfos[0].STAGEENDDATE',
    ],
    computed: ([MARKETENDDATE, SELLSTATE, MARKETBEGINDATE, GSVALUEDATE, ISAUTOCONTINUE, STAGEENDDATE]) => ({
      MARKETENDDATE,
      SELLSTATE,
      MARKETBEGINDATE,
      GSVALUEDATE,
      ISAUTOCONTINUE,
      STAGEENDDATE,
    }),
  },

  fixedBottomBtnInfo: {
    property: [
      'FundGDLCInfos[0].RATE',
      'FundGDLCInfos[0].SELLSTATE2',
      'FundGDLCInfos[0].PEOPLELIMITSP',
      'FundGDLCInfos[0].ISBUYREMIND',
      'FundGDLCInfos[0].FINTYPE',
      'FundGDLCInfos[0].BUYREMIND',
    ],
    computed: ([rate, sellState, peopleLimitSP, isBuyRemind, finType, buyRemind]) => ({
      rate,
      sellState,
      peopleLimitSP,
      isBuyRemind,
      finType,
      buyRemind,
    }),
  },

  achievementData: {
    property: [
      'FundGDLCInfos[0].MAXRETRAHY',
      'FundGDLCInfos[0].MAXRETRAY',
      'FundGDLCInfos[0].MAXRETRATWY',
      'FundGDLCInfos[0].MAXRETRATRY',
      'FundGDLCInfos[0].MAXRETRAFY',
      'FundGDLCInfos[0].MAXRETRASY',
      'FundGDLCInfos[0].MAXRETRASE',
      'FundGDLCInfos[0].SHARPSY',
      'FundGDLCInfos[0].SHARPSE',
      'FundGDLCInfos[0].SHARPHY',
      'FundGDLCInfos[0].SHARPY',
      'FundGDLCInfos[0].SHARPTWY',
      'FundGDLCInfos[0].SHARPTRY',
      'FundGDLCInfos[0].SHARPFY',
      'FundGDLCInfos[0].NVRENO_HY',
      'FundGDLCInfos[0].NVRENO_Y',
      'FundGDLCInfos[0].NVRENO_TWY',
      'FundGDLCInfos[0].NVRENO_TRY',
      'FundGDLCInfos[0].NVRENO_FY',
      'FundGDLCInfos[0].NVRENO_SY',
      'FundGDLCInfos[0].NVRENO_SE',
    ],
    computed: ([
      maxRetraHY,
      maxRetraY,
      maxRetraTWY,
      maxRetraTRY,
      maxRetraFY,
      maxRetraSY,
      maxRetraSE,
      sharpSY,
      sharpSE,
      sharpHY,
      sharpY,
      sharpTWY,
      sharpTRY,
      sharpFY,
      halfYearFixDay,
      oneYearFixDay,
      twoYearFixDay,
      threeYearFixDay,
      fiveYearFixDay,
      currentYearFixDay,
      establishedFixDay,
    ]) =>
      handleAchievementData({
        maxRetraHY,
        maxRetraY,
        maxRetraTWY,
        maxRetraTRY,
        maxRetraFY,
        maxRetraSY,
        maxRetraSE,
        sharpSY,
        sharpSE,
        sharpHY,
        sharpY,
        sharpTWY,
        sharpTRY,
        sharpFY,
        halfYearFixDay,
        oneYearFixDay,
        twoYearFixDay,
        threeYearFixDay,
        fiveYearFixDay,
        currentYearFixDay,
        establishedFixDay,
      }),
  },

  riskData: {
    property: [
      'FundGDLCInfos[0].MAXRETRAY',
      'FundGDLCInfos[0].MAXRETRATRY',
      'FundGDLCInfos[0].MAXRETRAFY',
      'FundGDLCInfos[0].SHARPY',
      'FundGDLCInfos[0].SHARPTRY',
      'FundGDLCInfos[0].SHARPFY',
      'FundGDLCInfos[0].NVRENO_Y',
      'FundGDLCInfos[0].NVRENO_TRY',
      'FundGDLCInfos[0].NVRENO_FY',
      'FundGDLCInfos[0].CALMAR_Y',
      'FundGDLCInfos[0].CALMAR_TRY',
      'FundGDLCInfos[0].CALMAR_FY',
      'fundIndict',
    ],
    computed: ([
      MAXRETRAY,
      MAXRETRATRY,
      MAXRETRAFY,
      SHARPY,
      SHARPTRY,
      SHARPFY,
      NVRENOY,
      NVRENOTRY,
      NVRENOFY,
      CALMARY,
      CALMARTRY,
      CALMARFY,
      rankInfo,
    ]) =>
      handleRiskData({
        MAXRETRAY,
        MAXRETRATRY,
        MAXRETRAFY,
        SHARPY,
        SHARPTRY,
        SHARPFY,
        NVRENOY,
        NVRENOTRY,
        NVRENOFY,
        CALMARY,
        CALMARTRY,
        CALMARFY,
        rankInfo,
      }),
  },

  onePageRead: {
    property: ['readOnePage'],
    computed: ([data]) => {
      if (isEmpty(data)) {
        return {};
      }
      const { productImgInfo, productImgUrl, id } = data;
      const size = productImgInfo?.split('*');
      return {
        id,
        url: productImgUrl,
        width: size?.[0],
        height: size?.[1],
      };
    },
  },

  sameTypeProduct: {
    property: ['FundSameGDLCInfos'],
    computed: ([data]) => SameTypeModel.objectArrayWithKeyValuesArray(data || []),
  },

  optimalInfo: {
    property: ["dailySelectionComment.comment"],
    computed: ([comment]) => ({
      optimalReason: comment,
      isOptimal: !isEmpty(comment),
    }),
  },

  bonusInfo: {
    property: ['FundBonus[0]'],
    computed: ([data]) => {
      if (isEmpty(data)) {
        return {};
      }
      return {
        date: data.PDATE,
        content: data.BONUS,
      };
    },
  },

  manager: {
    property: ['FundGDLCInfos[0].MANAGER'],
    computed: ([value]) => value || '--',
  },

  isOrganizeRecommend: {
    property: ['FundGDLCInfos[0].ISORGPROMOT'],
    computed: ([value]) => value - 0 === 1,
  },

  managerName: {
    property: ['FundGDLCInfos[0].FUNDCOMPANYNAME'],
    computed: ([value]) => value || '--',
  },

  nextOpenDate: {
    property: ['FundGDLCInfos[0].NEXTBEGINDATE', 'FundGDLCInfos[0].MARKETBEGINDATE'],
    computed: ([NEXTBEGINDATE, MARKETBEGINDATE]) => (tool.judgeTimeIsExpired(MARKETBEGINDATE) ? MARKETBEGINDATE : NEXTBEGINDATE),
  },

  netFixInfo: {
    property: [
      'FundGDLCInfos[0].NVRENO_HY',
      'FundGDLCInfos[0].NVRENO_HY_EDATE',
      'FundGDLCInfos[0].NVRENO_Y',
      'FundGDLCInfos[0].NVRENO_Y_EDATE',
      'FundGDLCInfos[0].NVRENO_TWY',
      'FundGDLCInfos[0].NVRENO_TWY_EDATE',
      'FundGDLCInfos[0].NVRENO_TRY',
      'FundGDLCInfos[0].NVRENO_TRY_EDATE',
      'FundGDLCInfos[0].NVRENO_FY',
      'FundGDLCInfos[0].NVRENO_FY_EDATE',
      'FundGDLCInfos[0].NVRENO_SY',
      'FundGDLCInfos[0].NVRENO_SY_EDATE',
      'FundGDLCInfos[0].NVRENO_SE',
      'FundGDLCInfos[0].NVRENO_SE_EDATE',
    ],
    computed: ([
      halfYearFixDay,
      halfYearFixDate,
      oneYearFixDay,
      oneYearFixDate,
      twoYearFixDay,
      twoYearFixDate,
      threeYearFixDay,
      threeYearFixDate,
      fiveYearFixDay,
      fiveYearFixDate,
      currentYearFixDay,
      currentYearFixDate,
      establishedFixDay,
      establishedFixDate,
    ]) => ({
      '6y': {
        fixDay: halfYearFixDay,
        fixDate: !isEmpty(halfYearFixDate) ? formatDate(new Date(halfYearFixDate.replace(/-/g, '/')), 'yyyy-MM-dd') : '--',
      },
      n: {
        fixDay: oneYearFixDay,
        fixDate: !isEmpty(oneYearFixDate) ? formatDate(new Date(oneYearFixDate.replace(/-/g, '/')), 'yyyy-MM-dd') : '--',
      },
      '2n': {
        fixDay: twoYearFixDay,
        fixDate: !isEmpty(twoYearFixDate) ? formatDate(new Date(twoYearFixDate.replace(/-/g, '/')), 'yyyy-MM-dd') : '--',
      },
      '3n': {
        fixDay: threeYearFixDay,
        fixDate: !isEmpty(threeYearFixDate) ? formatDate(new Date(threeYearFixDate.replace(/-/g, '/')), 'yyyy-MM-dd') : '--',
      },
      '5n': {
        fixDay: fiveYearFixDay,
        fixDate: !isEmpty(fiveYearFixDate) ? formatDate(new Date(fiveYearFixDate.replace(/-/g, '/')), 'yyyy-MM-dd') : '--',
      },
      jn: {
        fixDay: currentYearFixDay,
        fixDate: !isEmpty(currentYearFixDate) ? formatDate(new Date(currentYearFixDate.replace(/-/g, '/')), 'yyyy-MM-dd') : '--',
      },
      ln: {
        fixDay: establishedFixDay,
        fixDate: !isEmpty(establishedFixDate) ? formatDate(new Date(establishedFixDate.replace(/-/g, '/')), 'yyyy-MM-dd') : '--',
      },
    }),
  },

  profitInfo: {
    property: [
      'FundGDLCInfos[0].Q_3_YEAR',
      'FundGDLCInfos[0].HY_3_YEAR',
      'FundGDLCInfos[0].Y_3_YEAR',
      'FundGDLCInfos[0].TWY_3_YEAR',
      'FundGDLCInfos[0].PQ_3_YEAR',
      'FundGDLCInfos[0].PHY_3_YEAR',
      'FundGDLCInfos[0].PY_3_YEAR',
      'FundGDLCInfos[0].PTWY_3_YEAR',
    ],
    computed: ([
      threeMonthAvgProfit,
      halfYearAvgProfit,
      oneYearAvgProfit,
      twoYearAvgProfit,
      threeMonthProfitProbability,
      halfYearProfitProbability,
      oneYearProfitProbability,
      twoYearProfitProbability,
    ]) => {
      // 保留两位小数+%
      const format = (value, isProfit = false) => {
        const res = isEmpty(value) ? '--' : `${numeral(value * (isProfit ? 100 : 1)).format('0.00')}%`;
        return Number(value) === 1 && isProfit ? '99.99%' : res;
      };
      const handleData = (avgProfit, profitProbability) => ({
        avgProfit: format(avgProfit),
        avgProfitValue: avgProfit,
        profitRate: format(profitProbability, true),
        percent: Number(profitProbability) === 1 ? 0.99 : profitProbability,
      });
      return {
        '3y': handleData(threeMonthAvgProfit, threeMonthProfitProbability),
        '6y': handleData(halfYearAvgProfit, halfYearProfitProbability),
        n: handleData(oneYearAvgProfit, oneYearProfitProbability),
        '2n': handleData(twoYearAvgProfit, twoYearProfitProbability),
      };
    },
  },

  isShowFundSize: {
    property: ['FundGDLCInfos[0].ISPVT'],
    computed: ([value]) => parseInt(value, 10) === 1,
  },

  redemAndAchieveInfo: {
    property: ['FundGDLCInfos[0].ACHIEVETYPE', 'FundGDLCInfos[0].ACHIEVESECTION', 'FundGDLCInfos[0].ACHIEVEEFFDATE', 'FundGDLCInfos[0].ACCRUALRATE'],
    computed: ([achieveType, achieveSection, achieveEffectiveDate, accrualRate]) => ({
      achieveType: isEmpty(achieveType) ? '' : parseInt(achieveType, 10),
      achieveSection,
      achieveEffectiveDate,
      accrualRate: isEmpty(accrualRate) ? '--' : `${numeral(accrualRate).format('0.00')}%`,
    }),
  },

  hasSeasonReport: {
    property: ['reportDateList'],
    computed: ([val]) => !isEmpty(val),
  },

  readInfo: {
    property: [
      'FundGDLCInfos[0].BRIGHTPOINT',
      'FundGDLCInfos[0].DIRECTION',
      'FundGDLCInfos[0].STRATEGY',
      'FundGDLCInfos[0].ACHIEVEMENT',
      'FundGDLCInfos[0].MANAGEABILITY',
      'FundGDLCInfos[0].INTERPRETPIC',
    ],
    computed: ([brightPoint = '', direction = '', strategy = '', achievement = '', manageAbility = '', interpretImg = '']) => {
      const info = {
        brightPoint,
        direction,
        strategy,
        achievement,
        manageAbility,
        interpretImg,
      };
      const isAllEmpty = (Object.values(info) || []).every((item) => isEmpty(item));
      if (isAllEmpty) {
        return [];
      }
      return Object.keys(info)
        .map((key) => {
          if (!isEmpty(info[key])) {
            const { icon = '', title = '' } = readTitleMap[key];
            return {
              key,
              title,
              icon,
              desc: info[key],
            };
          }
          return null;
        })
        .filter((item) => !isEmpty(item));
    },
  },

  readUpdateTime: {
    property: ['FundGDLCInfos[0].INTERPRETATION_TIME'],
    computed: ([time]) => (dayjs(time).isValid() && !isEmpty(time) ? dayjs(time).format('YYYY年MM月') : ''),
  },

  noticeData: {
    property: ['gdlcReportConfig'],
    computed: ([config]) => {
      const { ILLUSTRATION, ISBUTTON, BUTTON, LINKURL, LINKTYPE } = config || {};
      return {
        content: ILLUSTRATION,
        isShowButton: parseInt(ISBUTTON, 10) === 1,
        buttonText: BUTTON,
        linkUrl: LINKURL,
        linkType: LINKTYPE,
      };
    },
  },

  promotionModuleConfig: {
    property: ['promotionConfigLabel'],
    computed: ([labelConfig]) => {
      const { button, cId, description, linkUrl, pic, title, type } = labelConfig || {};
      return {
        button, // 按钮
        cId, // 配置策略id
        description, // 描述
        linkUrl, // 跳转地址
        pic, // 图片
        title, // 标题
        type, // 产品线：1-稳健理财；2-活期管理；3-稳健增强；4-进阶理财；5-另类配置
      };
    },
  },

  noticeInfo: {
    property: ['FundGDLCInfos[0].CLOSEDATE'],
    computed: ([date]) => {
      const formatedDate = dayjs(date).isValid() && !isEmpty(date) ? dayjs(date).format('YYYY年MM月DD日') : '';
      return isEmpty(formatedDate)
        ? {}
        : {
            text: `该基金已终止，导致${formatedDate}净值和收益率大幅波动。`,
          };
    },
  },

  historyProfitInfo: {
    property: ['historyProfitExtractionList.extractionList', 'historyProfitExtractionList.isInBlacklist', 'FundGDLCInfos[0].STABILSHDATE'],
    computed: ([extractionList, isInBlacklist, establishDate]) => {
      // 日期：由近到远
      const changeList = (extractionList || [])
        .map((item) => ProfitModel.objectWithKeyValues(item))
        .filter((item) => !item.achieveEffectiveDate || dayjs(item.achieveEffectiveDate).isValid());
      const changeAfterSymbol = changeList.some((item) => dayjs(item.achieveEffectiveDate).isAfter(dayjs('2024-08-05')));
      return {
        changeList,
        changeTimes: Math.max(changeList?.length - 1, 0),
        isInBlacklist: Boolean(isInBlacklist) || false,
        establishDate,
        changeAfterSymbol,
      };
    },
  },

  achievePoint: {
    property: ['historyProfitExtractionList.extractionList', 'historyProfitExtractionList.isInBlacklist'],
    computed: ([extractionList, isInBlacklist]) => {
      // 日期：由近到远
      // 在黑名单里不展示点和旗
      if (isInBlacklist) {
        return [];
      }
      return (extractionList || []).map((item) => item.ACHIEVEEFFDATE).filter((item) => item && dayjs(item).isValid());
    },
  },

  isHighEndEnjoy: {
    property: ['FundGDLCInfos[0].ISPVT'],
    computed: ([value]) => parseInt(value, 10) !== 1,
  },

};

export default new Model(property, replaceProperty);
